import React from 'react'
const ArrowIcon = () => {
	return (
		<svg
			width="10"
			height="18"
			viewBox="0 0 10 18"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.848 8.938l-.726-.782L1.554 0 0 1.564l6.841 7.374L0 16.313l1.554 1.564 7.568-8.156z"
				fill="currentColor"
			/>
		</svg>
	)
}
export default ArrowIcon
